<template>
  <div class="problem-box">
    <div class="search-header">
      <div>
        <template>
          <el-tag
            v-for="(item, index) in cateList"
            :key="index"
            effect="plain"
            type="info"
            class="cate-tag"
            :class="activeCate === item ? 'cate-tag--active' : ''"
            v-if="item !== '使用帮助'"
            @click="onTagClick(item)"
          >{{ item }}</el-tag>
        </template>
      </div>

      <div class="search-bar">
        <input v-model="keyword" class="search-input" confirm-type="search" :placeholder="productPage.placeholderTextOne" @keyup.enter="getValue" @input="changeValue"/>
        <img src="../../assets/images/public/i35.png" @click="getValue" />
      </div>
    </div>
    <div class="js_wrap" v-loading.fullscreen="isSearching" :element-loading-text="search.searchLoadingText">
      <ul v-if="questionList && questionList.length > 0">
        <li v-for="(item,index) in questionList" :key="item.id" @click="toDetails(item, index)">
          <div class="js_wrap_title" v-html="$convertPxToRem(handleHighlightKeywordForString(item[`${currentLang.prefix}title_desc`]))"></div>
          <div  class="js_wrap_content" v-html="$convertPxToRem(handleHighlightKeywordForString(item[`${currentLang.prefix}content_title`]))"></div>
        </li>
      </ul>
      <div class="search-none" v-else-if="!isPageInit">
        <el-empty :description="search.searchResultNone"></el-empty>
      </div>
    </div>
    <div class="sc_pagi">
      <el-pagination :current-page="page" background layout="prev, pager, next" :page-size="10" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <feedback-popup></feedback-popup>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { getProductQuestion } from "@/utils/http.js";
export default {
  data() {
    return {
      dataInfo: {},
      questionList: [],
      keyword:'',
      total:0,
      page:1,
      cateList: [],
      activeCate: '全部',
      isPageInit: true,
      isSearching: false,
      isSearched:false
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    productPage() {
      return this.currentLang.config.productPage
    },
    navbar() {
      return this.currentLang.config.navbar
    },
    search() {
      return this.currentLang.config.search
    },
  },

  created() {
    if(this.$route.query.activeCate){
      this.activeCate = this.$route.query.activeCate
    }else{
      this.activeCate='全部'
    }
    console.log('this.$route.query.activeCate',this.activeCate)
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    }else{
      this.page = 1
    }
  },
  mounted() {
    
    if(this.$route.query.keyword){
      this.keyword = this.$route.query.keyword
    }
    
    this.getQuestionList();
  },
  methods: {
    onTagClick(val) {
      this.activeCate = val
      this.page = 1
      this.$router.push({
        query: {
          ...this.$route.query,
          activeCate: this.activeCate,
          page: 1
        }
      })
      this.getQuestionList()
    },

    getQuestionList() {
      if (!this.isPageInit) {
        this.isSearching = true
      }
      getProductQuestion({
        keyword: this.keyword,
        page: this.page,
        limit: 10,
        title: this.activeCate,
      }).then(res => {
        if (res.code === 1) {
          if (this.isPageInit) {
            this.cateList = 
              res.data[`${this.currentLang.prefix}title_list`] && res.data[`${this.currentLang.prefix}title_list`].length > 0
              ? res.data[`${this.currentLang.prefix}title_list`]
              : []
            // this.activeCate = this.cateList.length > 0 ? this.cateList[0] : this.activeCate
            this.isPageInit = false
          }
          this.dataInfo = res.data
          this.total = res.data.count;
          this.questionList = res.data.list;
          if (res.data.count < 1 && this.questionList.length < 1) {
            this.$message.warning(this.search.searchResultNone)
          }
        }
        else {
          this.$message.error(err.msg)
        }
      })
      .catch(err => {
        this.$message.error(err.msg)
      })
      .finally(() => {
        this.isSearching = false
      });
    },

    handleHighlightKeywordForString(str) {
      if (!str) return str
      if (!this.keyword.trim()) return str
      if(!this.isSearched) return str
      const re = new RegExp(this.keyword, "g")
      const newStrEle = `<strong style="color:red;background:yellow;display:inline-block;">${this.keyword}</strong>`
      return str.replace(re, newStrEle)
    },

    toDetails(info, index) {
      // console.log('info', info)
      // return
      this.$router.push({
        path: "/detail",
        query: {
          index: index, 
          page: this.page,
          keyword: this.keyword,
          activeCate: this.activeCate,
          page: this.page
        }})
    },
    getValue(){
      this.page = 1
      this.isSearched = true
      this.getQuestionList()
    },
    changeValue(){
      console.log(123)
this.isSearched = false
    },
    handleCurrentChange(val) {
      this.page = val
      this.$router.push({
        query: {
          ...this.$route.query,
          page: val
        }
      })
      this.getQuestionList()
      
    },
  }
};
</script>
<style lang="scss" scoped>
.problem-box {
  margin: auto;
  padding: 40px 0;
  width: 1200px;
}

.search-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .cate-tag {
    margin-right: 10px;
    cursor: pointer;
    background-color: var(--main-color-blue);
    background-color: #c0c4cc;
    border-color: transparent;
    border-radius: 20px;
    color: #000;
    font-size: 16px;
    transition: all 0.3s;
  }

  .cate-tag:hover,
  .cate-tag--active {
    background-color: var(--main-color-blue);
    color: #fff;
  }

  .search-bar {
    overflow: hidden;
    width: 25%;
    height: 35px;
    border-radius: 25px;
    background-color: white;
    display: flex;
    align-items: center;
    border: 1px solid #B2B2B2;
  }

  .search-input {
    height: 100%;
    width: 95%;
    margin-left: 10px;
    padding: 0 15px 0 5px;
    border: 0;
    outline: none;
  }

  .search-bar img {
    width: 15px;
    height: 15px;
    margin-right: 10px;
    cursor: pointer;
  }
}


.js_wrap {
  width: 1200px;
  height: auto;
  margin: 50px auto;
  ul {
    width: 1200px;
    flex-wrap: wrap;
    display: flex;
  }

  li {
    width: calc(1200px / 2 - 80px);
    height: auto;
    margin: 30px 40px;
    padding-bottom: 30px;
    cursor: pointer;
    .js_wrap_content {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /*省略几行写几*/
      -webkit-box-orient: vertical;
      margin-top: 10px;
      color: #666;
    }
    .js_wrap_title {
      color: #063358;
      font-weight: 500;
      font-size: 24px;
    }
  }
}
.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}

.search-none {
    text-align: center;
    width: 100%;
    font-size: 24px;
    font-weight: 300;
    color: #999;
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/pages/cpzy/problem.vue